import { combineReducers, combineSlices, configureStore } from '@reduxjs/toolkit';
import { wishlistSlice } from './wishlistSlice';
import { cartSlice } from './cartSlice';
import { sessionSlice } from './sessionSlice';
import { productCollapsiblesSlice } from './productCollapsiblesSlice';

export const makeStore = () => {
  return configureStore({
    reducer: combineSlices({
      cart: cartSlice.reducer,
      wishlist: wishlistSlice.reducer,
      session: sessionSlice.reducer,
      productCollapsibles: productCollapsiblesSlice.reducer
    }),
  });
};

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
